import { Component, Input } from '@angular/core';
import { Project } from '../../../models/index';
import { LocaleAwareBaseComponent } from './../../../seo/locale-aware-base.component';

@Component({
  selector: 'app-map-plan-project-mobile-base',
  templateUrl: './map-plan-project-mobile-base.component.html',
  styleUrls: ['./map-plan-project-mobile-base.component.scss']
})
export class MapPlanProjectMobileBaseComponent extends LocaleAwareBaseComponent {
  @Input() projects: Project;

  constructor() {
    super();
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/map-plan/map-plan-project-mobile-base.component.ts